import { createAsyncThunk } from "@reduxjs/toolkit";
import { IUser } from "../../../models/IUser";
import { thunkHandlers } from "../../../store/thunkHandlers";
import { filesAPI } from "../../files/api";
import { userAPI } from "../api";
import { RootState } from "../../../store";
import { cropAvatar } from "./avatar";

export const fetchGetAllUsers = createAsyncThunk("fetch_get_all_users", async (_, { dispatch, rejectWithValue }) => {
    try {
        return await userAPI.getAll();
    } catch (e) {
        return rejectWithValue(thunkHandlers.error(e, dispatch));
    }
});

export const fetchUpdateUser = createAsyncThunk(
    "fetch_update_user",
    async (updateData: IUser, { dispatch, rejectWithValue }) => {
        try {
            return await userAPI.update(updateData);
        } catch (e) {
            return rejectWithValue(thunkHandlers.error(e, dispatch));
        }
    },
);

interface IUpdateRole {
    id: string;
    role_id: number;
}

export const fetchUpdateUserRole = createAsyncThunk(
    "fetch_update_user_role",
    async ({ id, role_id }: IUpdateRole, { dispatch, rejectWithValue }) => {
        try {
            return await userAPI.updateRole(id, role_id);
        } catch (e) {
            return rejectWithValue(thunkHandlers.error(e, dispatch));
        }
    },
);

interface IUpdateStatus {
    id: string;
    status_id: number;
}

export const fetchUpdateUserStatus = createAsyncThunk(
    "fetch_update_user_status",
    async ({ id, status_id }: IUpdateStatus, { dispatch, rejectWithValue }) => {
        try {
            return await userAPI.updateStatus(id, status_id);
        } catch (e) {
            return rejectWithValue(thunkHandlers.error(e, dispatch));
        }
    },
);

interface IUploadPhoto {
    user: IUser;
    file: File;
}

/**
 * Аватар (S4): квадрат 256×256 JPEG по центру → POST /api/file → имя файла
 * в `avatar_path` своим PUT /api/users. Старый файл не удаляется: его ещё
 * показывают загруженные у коллег доски и ленты.
 */
export const fetchUploadUserPhoto = createAsyncThunk<IUser, IUploadPhoto, { state: RootState }>(
    "fetch_update_user_photo",
    async ({ file, user }: IUploadPhoto, { rejectWithValue, dispatch }) => {
        try {
            const name = await filesAPI.upload(await cropAvatar(file));
            return await userAPI.update({ ...user, avatar_path: name });
        } catch (e) {
            return rejectWithValue(thunkHandlers.error(e, dispatch));
        }
    },
);

/** «Удалить фото»: `avatar_path = null`. */
export const fetchRemoveUserPhoto = createAsyncThunk(
    "fetch_remove_user_photo",
    async (user: IUser, { rejectWithValue, dispatch }) => {
        try {
            return await userAPI.update({ ...user, avatar_path: null });
        } catch (e) {
            return rejectWithValue(thunkHandlers.error(e, dispatch));
        }
    },
);